import { useUpdateEffect } from 'ahooks';
import { useState } from 'react';

export default function useDrawerFullPlacement(props: { isOpen: boolean }) {
  const [placement, setPlacement] = useState<'bottom' | 'top'>('bottom');
  useUpdateEffect(() => {
    if (!props.isOpen) return;

    const timer = setTimeout(() => {
      if (!props.isOpen) return;
      setPlacement('top');
    }, 300);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [props.isOpen]);

  return [placement, setPlacement] as const;
}
